import { ZAKAZNIK_CDB } from '@/modules/kartoteka/partner/constants';

export { DMS_MODULE } from '../../constants';

export const ZAKAZNIK = 'Zakaznik';
export const NAME = ZAKAZNIK_CDB;
export const CRUMB_LABEL_KEY = 'grdZakCdb';
